import {type RefObject, useCallback, useState} from 'react'

import {DeleteSavedViewDialog} from '../components/views/DeleteSavedViewDialog'
import type {SavedView} from '../components/views/types'

interface UseDeleteSavedViewDialogOptions {
  owner: string
  repo: string
  onDeleted?: (view: SavedView) => void
  returnFocusRef?: RefObject<HTMLElement | null>
}

export function useDeleteSavedViewDialog({owner, repo, onDeleted, returnFocusRef}: UseDeleteSavedViewDialogOptions) {
  const [pendingDelete, setPendingDelete] = useState<SavedView | null>(null)

  const openDeleteDialog = useCallback(
    (view: SavedView, returnFocusTarget: HTMLElement | null = null) => {
      if (returnFocusRef) returnFocusRef.current = returnFocusTarget
      setPendingDelete(view)
    },
    [returnFocusRef],
  )

  const deleteDialog = pendingDelete ? (
    <DeleteSavedViewDialog
      view={pendingDelete}
      owner={owner}
      repo={repo}
      onClose={() => setPendingDelete(null)}
      onSuccess={() => onDeleted?.(pendingDelete)}
      returnFocusRef={returnFocusRef}
    />
  ) : null

  return {openDeleteDialog, deleteDialog, isDeleteDialogOpen: pendingDelete !== null}
}
